import 'core-js/proposals/reflect-metadata';

import PerfilDTOGenerico from './PerfilDTOGenerico';

class AreaFormacaoDTO extends PerfilDTOGenerico {
    constructor() {
        super();
    }
}

export default AreaFormacaoDTO;
